const PIX_ERROR_CODES = {
  EMAIL_NOT_FOUND: 1000,
  PHONE_NOT_FOUND: 1001,
  RANDOM_KEY_NOT_FOUND: 1002,
  PIX_KEY_NOT_FOUND: 1003,
  INVALID_EMAIL: 1004,
  INVALID_PHONE: 1005,
  INVALID_RANDOM_KEY: 1006,
  UNKNOWN_ERROR: 1007,
  PING_PAY_INVALID_REQUEST_UNKNOWN_ERROR: 1008,
  PING_PAY_LIVENESS_NOT_APPROVED: 1009,
  USER_MUST_BE_OWNER_OF_BANK_ACCOUNT: 1010,
  PING_PAY_TOO_MANY_REQUESTS: 1011,
  PING_PAY_BANK_NOT_ALLOWED: 1012,
}

const getPixErrorMessage = (errorCode, translate) => {
  const errorMessages = {
    [PIX_ERROR_CODES.EMAIL_NOT_FOUND]: 'payments.pix.errors.emailNotFound',
    [PIX_ERROR_CODES.PHONE_NOT_FOUND]: 'payments.pix.errors.phoneNotFound',
    [PIX_ERROR_CODES.RANDOM_KEY_NOT_FOUND]:
      'payments.pix.errors.randomKeyNotFound',
    [PIX_ERROR_CODES.PIX_KEY_NOT_FOUND]: 'payments.pix.errors.pixKeyNotFound',
    [PIX_ERROR_CODES.INVALID_EMAIL]: 'payments.pix.errors.invalidEmail',
    [PIX_ERROR_CODES.INVALID_PHONE]: 'payments.pix.errors.invalidPhone',
    [PIX_ERROR_CODES.INVALID_RANDOM_KEY]:
      'payments.pix.errors.invalidRandomKey',
    [PIX_ERROR_CODES.UNKNOWN_ERROR]: 'payments.pix.errors.unknownError',
    [PIX_ERROR_CODES.PING_PAY_INVALID_REQUEST_UNKNOWN_ERROR]:
      'payments.pix.errors.pingPayInvalidRequestUnknownError',
    [PIX_ERROR_CODES.PING_PAY_LIVENESS_NOT_APPROVED]:
      'payments.pix.errors.pingPayLivenessNotApproved',
    [PIX_ERROR_CODES.USER_MUST_BE_OWNER_OF_BANK_ACCOUNT]:
      'payments.pix.errors.userMustBeOwnerOfBankAccount',
    [PIX_ERROR_CODES.PING_PAY_TOO_MANY_REQUESTS]:
      'payments.pix.errors.pingPayTooManyRequests',
    [PIX_ERROR_CODES.PING_PAY_BANK_NOT_ALLOWED]:
      'payments.pix.errors.bankNotAllowed',
  }

  const messageKey =
    errorMessages[errorCode] || 'payments.pix.errors.generalError'
  return translate(messageKey)
}

export const handlePixError = (error, translate) => {
  if (!error?.messageCode) {
    return translate('payments.pix.errors.generalError')
  }

  return getPixErrorMessage(error.messageCode, translate)
}

export { PIX_ERROR_CODES }
